// extracted by css-extract-rspack-plugin
export default {"sticky_banner":"wwKsv","stickyBanner":"wwKsv","icon":"wvTAk","texts":"Hkyo2","title":"qRzt5","category":"mCAR2"};